import React from 'react';
import { Grid } from '@mantine/core';

export default function ManagementLayout({ dataComponent, createComponent }) {
  if (!createComponent) {
    return dataComponent;
  }

  return (
    <Grid>
      <Grid.Col span={{ base: 12, md: 6, lg: 8 }}>{dataComponent}</Grid.Col>
      <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
        <div style={{ position: 'sticky', top: 10 }}>{createComponent}</div>
      </Grid.Col>
    </Grid>
  );
}
